import { render, staticRenderFns } from "./ReorderModal.vue?vue&type=template&id=1866fdb3&scoped=true"
import script from "./ReorderModal.vue?vue&type=script&lang=js"
export * from "./ReorderModal.vue?vue&type=script&lang=js"
import style0 from "./ReorderModal.vue?vue&type=style&index=0&id=1866fdb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1866fdb3",
  null
  
)

export default component.exports